function sortableTableController() {
	let isSortedTable = false;

	const sorttable = {
		init() {
			if (isSortedTable) return;
			isSortedTable = true;

			$('.js-sortable-table').each((_, table) => {
				sorttable.makeSortable(table);
			});

			// delegated click (fix)
			$(document).on('click', '.js-sortable-table-sorter', function (e) {
				const table = $(this).closest("table")[0];
				if (!table) return;

				// const colNum = parseInt($(this).data('sortable-table-col'), 10);
				const colNum = this.cellIndex;
				const $target = $(this);

				const isAsc = $target.hasClass('sorttable_sorted');
				const isDesc = $target.hasClass('sorttable_sorted_reverse');
				
				$target
					.siblings('.js-sortable-table-sorter')
					.removeClass('sorttable_sorted sorttable_sorted_reverse');

				if (!isAsc && !isDesc) {
					sorttable.sortColumn(table, colNum);
					$target.addClass('sorttable_sorted');
					return;
				}

				// 👉 TOGGLE → DESC
				if (isAsc) {
					Object.values(table.tBodies).forEach(function (tbody) {
						if (tbody) sorttable.reverse(tbody);
					});
					$target
						.removeClass('sorttable_sorted')
						.addClass('sorttable_sorted_reverse');
					return;
				}

				// 👉 TOGGLE → ASC
				if (isDesc) {
					Object.values(table.tBodies).forEach(function (tbody) {
						if (tbody) sorttable.reverse(tbody);
					});
					$target
						.removeClass('sorttable_sorted_reverse')
						.addClass('sorttable_sorted');
					return;
				}
			});
		},

		sortColumn(table, col) {
			const visibleTbody = $(table).find("tbody:visible")[0];
			if (!visibleTbody) return;

			if (!table.tHead || !table.tHead.rows.length) return;
			const headCell = table.tHead.rows[0].cells[col];
			if (!headCell) return;

			const rows = Array.from($(visibleTbody).find("tr:visible"));
			const sortType = $(headCell).data('sortable-type') || sorttable.guessType(table, col);
			const rowArray = rows.map(row => [$(row.cells[col]), row]);

			rowArray.sort(sorttable[sortType]);

			rowArray.forEach(([, row]) => {
				visibleTbody.appendChild(row);
			});
		},

		makeSortable(table) {
			const sortbottomrows = [];

			Array.from(table.rows).forEach(row => {
				if ($(row).hasClass('sortbottom')) {
					sortbottomrows.push(row);
				}
			});

			if (sortbottomrows.length > 0) {
				let tfoot = table.tFoot || table.createTFoot();
				sortbottomrows.forEach(row => tfoot.appendChild(row));
			}

			Array.from(table.tHead.rows[0].cells).forEach((cell, i) => {
				if (!cell.className.includes('sorttable_nosort')) {
					cell.sorttable_sortfunction = sorttable.guessType(table, i);
				}
			});			
		},

		guessType(table, column) {
			let numericCount = 0;
			let dateCount = 0;
			let alphaCount = 0;

			const dateRegex = /^\d{1,2}\s[a-zA-Z]{3}\s\d{4}$/;

			const visibleTbody = $(table).find("tbody:visible")[0];
			if (!visibleTbody) return "sort_alpha";

			const rows = Array.from(visibleTbody.rows);

			for (const row of rows.slice(0, 5)) {
				const cell = row.cells[column];
				if (!cell) continue;

				const text = $(cell).text() || "";
				const trimmed = text.trim();
				if (!trimmed) continue;

				if (/^-?[£$¤]?[\d,.]+%?$/.test(trimmed)) {
					numericCount++;
					continue;
				}

				if (dateRegex.test(trimmed)) {
					dateCount++;
					continue;
				}

				alphaCount++;
			}

			if (dateCount > numericCount && dateCount > alphaCount)
				return "sort_by_date";

			if (numericCount > dateCount && numericCount > alphaCount)
				return "sort_numeric";

			return "sort_alpha";
		},

		reverse(tbody) {
			const rows = Array.from(tbody.rows);
			for (let i = rows.length - 1; i >= 0; i--) {
				tbody.appendChild(rows[i]);
			}
		},

		sort_numeric(a, b) {
			const parse = val => parseFloat(val[0].text().replace(/[^0-9.-]/g, '')) || 0;
			return parse(a) - parse(b);
		},

		sort_alpha(a, b) {
			const aText = a[0].text().trim().toUpperCase();
			const bText = b[0].text().trim().toUpperCase();
			return aText.localeCompare(bText);
		},

		sort_by_date(a, b) {
			const parseDate = (val) => {
				val = val.trim();

				if (!val || val.toLowerCase() === "null") return -Infinity;

				// Fix invalid placeholder dates
				if (val === "01 Jan 0001") return -Infinity;

				const parsed = Date.parse(val);
				return isNaN(parsed) ? -Infinity : parsed;
			};

			const aDate = parseDate(a[0].text());
			const bDate = parseDate(b[0].text());

			return aDate - bDate; // ASC by default
		},

		sort_checkbox(a, b) {
			const aChecked = a[0].find('input[type=checkbox]').prop('checked');
			const bChecked = b[0].find('input[type=checkbox]').prop('checked');
			return (aChecked === bChecked) ? 0 : (aChecked ? 1 : -1);
		},

		shaker_sort(list, compFunc) {
			let b = 0, t = list.length - 1, swap = true;
			while (swap) {
				swap = false;
				for (let i = b; i < t; ++i) {
					if (compFunc(list[i], list[i + 1]) > 0) {
						[list[i], list[i + 1]] = [list[i + 1], list[i]];
						swap = true;
					}
				}
				t--;
				if (!swap) break;
				for (let j = t; j > b; --j) {
					if (compFunc(list[j], list[j - 1]) < 0) {
						[list[j], list[j - 1]] = [list[j - 1], list[j]];
						swap = true;
					}
				}
				b++;
			}
		},

		// icons sorting
		sort_icon(a, b) {
			const getIconType = val => {
				const useElement = val[0].find('use');
				if (useElement.length) {
					const href = useElement.attr('xlink:href') || useElement.attr('href');
					if (href && href.indexOf('#email') !== -1) {
						return 1;
					}
				}
				return 0; // Inactive (minus icon) or no icon
			};
			return getIconType(a) - getIconType(b); // Sort active (1) before inactive (0)
		},
	};

	// forEach implementation
	const forEach = (object, block, context) => {
		if (!object) return;

		if (typeof object.forEach === 'function') {
			object.forEach(block, context);
		} else if (typeof object.length === 'number') {
			Array.prototype.forEach.call(object, block, context);
		} else {
			for (const key in object) {
				if (Object.prototype.hasOwnProperty.call(object, key)) {
					block.call(context, object[key], key, object);
				}
			}
		}
	};

	sorttable.init();
}

export default sortableTableController;
